export const ONBOARDING_VISIBILITY = 'ONBOARDING_VISIBILITY';

export function setOnboardingVisibility(id, visible) {
    let payload = { [id]: visible };

    return {
        type: ONBOARDING_VISIBILITY,
        payload: payload,
        persistent: true,
    };
}
